import React from 'react';
import { SvgIcon } from '@mui/material';

const MotoIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 80 56.71" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        className="st0"
        d="M15 5 A 1.0001 1.0001 0 1 0 15 7L17.359375 7L21.046875 14.990234C19.812861 15.90307 19 17.356539 19 19C19 21.749579 21.250421
            24 24 24C26.749579 24 29 21.749579 29 19C29 16.250421 26.749579 14 24 14C23.606807 14 23.228985 14.057613 22.861328 14.144531L20.947266
            10L22 10L22 7L20.5 7C20.195746 7 19.914259 7.0921754 19.677734 7.2480469L19.175781 6.1621094C18.850003 5.4545914 18.137409 5 17.359375 5L15
            5 z M 5.5 10C4.8481216 10 4.2984868 10.41875 4.0917969 11L2 11 A 1.0001 1.0001 0 1 0 2 13L5 13L5.6738281 13L5.3828125 14.023438C5.2556006
            14.01353 5.1298367 14 5 14C2.243 14 0 16.243 0 19C0 21.757 2.243 24 5 24C7.4143633 24 9.433596 22.279096 9.8984375 20L13.947266 20L14 20 A
            1.0007574 1.0007574 0 0 0 14.046875 20L15 20L15.359375 20C16.312375 20 17.133313 19.327578 17.320312 18.392578L18 15L12.867188 15L11.724609
            13L13 13L19 13L18.46875 11.792969C17.98975 10.703969 16.912656 10 15.722656 10L12 10C11.372438 10 10.819739 10.29422 10.453125 10.746094L5.7460938
            10.019531L5.7402344 10.025391C5.6612344 10.012391 5.583 10 5.5 10 z M 7.7539062 13L9.4179688 13L12.275391 18L6.3261719 18L6.8964844 16L8.9746094
            16C8.5295279 15.411595 7.9574472 14.923894 7.3027344 14.576172L7.7539062 13 z M 24 16C25.668699 16 27 17.331301 27 19C27 20.668699 25.668699 22
            24 22C22.331301 22 21 20.668699 21 19C21 18.15103 21.34795 17.393032 21.90625 16.849609L23.091797 19.419922 A 1.0005834 1.0005834 0 0 0 24.908203
            18.580078L23.730469 16.027344C23.820795 16.019319 23.907427 16 24 16 z M 4.8125 16.019531L4.0820312 18.576172 A 1.0001 1.0001 0 0 0 4.0097656 19.212891
            A 1.0001 1.0001 0 0 0 5.2304688 20L7.8164062 20C7.4021391 21.161251 6.3016094 22 5 22C3.346 22 2 20.654 2 19C2 17.410258 3.2472651 16.118546 4.8125 16.019531 z"
      />
    </SvgIcon>
  );
};

export default MotoIcon;
